import React, { Component } from 'react'
import { TouchableOpacity, StyleSheet } from 'react-native'

export default class GlowOpacity extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {

    return (
      <TouchableOpacity
        activeOpacity={1}
        style={[{ cursor: 'inherit' }, this.props.style, this.state.hover ? {borderColor: this.props.glowColor} : {}]}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
      >
        <TouchableOpacity children={this.props.children} onPress={this.props.onPress} />
      </TouchableOpacity>
    )
  }
}

  
const styles = StyleSheet.create({  
    outerStyle: {
    }
})  